export * from './baPictureUploader.component';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/baPictureUploader/index.ts